import { InputNumber } from "primereact/inputnumber";
import { useMemo } from "react";

// Icons
import { TbPigMoney } from "react-icons/tb";

// Types
import type { IVGVProps } from "./types";

export function VGV({ houseAmount, houseAmountCache, setHouseAmount }: IVGVProps) {

    // AUX Variables
    const HOUSE_AMOUNT_DEFAULT = useMemo(() => houseAmountCache, [houseAmountCache])

    const PESSIMISTA = useMemo(() => HOUSE_AMOUNT_DEFAULT - (HOUSE_AMOUNT_DEFAULT * (10 / 100)), [HOUSE_AMOUNT_DEFAULT])
    const OTIMISTA = useMemo(() => HOUSE_AMOUNT_DEFAULT + (HOUSE_AMOUNT_DEFAULT * (10 / 100)), [HOUSE_AMOUNT_DEFAULT])

    return (
        <span style={{
            maxWidth: 'calc(50% - 0.75rem)',
            minWidth: 'calc(50% - 0.75rem)',
        }} className="max-sm:!w-full max-sm:!min-w-full max-sm:!max-w-ful md:flex-1 h-auto flex flex-col justify-start gap-3
                rounded-xl
                border-slate-200 border-[1px]
                bg-white shadow-md overflow-hidden
            "
        >
            <span className="w-full flex flex-row items-center gap-2 px-4 pt-4 pb-2 border-slate-200 border-b-[1px]">
                <TbPigMoney size={25} />
                <span className="font-semibold">VGV</span>
            </span>

            <span className="w-full h-auto flex flex-col gap-3 p-4  [&_label]:cursor-pointer [&_label]:transition-all [&_label]:duration-[0.2s] ">

                <input type="radio" name="vgv_option" id="vgv_provavel" className="peer/VGVOption hidden" />
                <input type="radio" name="vgv_option" id="vgv_pessimista" className="peer/VGVOption1 hidden" />
                <input type="radio" name="vgv_option" id="vgv_otimista" className="peer/VGVOption2 hidden" />

                <label title="Clique para selecionar" htmlFor="vgv_provavel" onClick={() => setHouseAmount(HOUSE_AMOUNT_DEFAULT)} className="w-full h-auto
                    peer-checked/VGVOption:bg-slate-200  p-2 rounded-xl
                    flex flex-row items-center justify-between gap-4 hover:bg-slate-100">
                    <span>Provável</span>
                    <InputNumber
                        mode="currency"
                        currency="BRL"
                        locale="pt-BR"
                        minFractionDigits={2}
                        value={HOUSE_AMOUNT_DEFAULT}
                        min={HOUSE_AMOUNT_DEFAULT}
                        onValueChange={(e) => setHouseAmount(e.value || 0)}
                    />
                </label>

                <label title="Clique para selecionar" htmlFor="vgv_pessimista" onClick={() => setHouseAmount(PESSIMISTA)} className="w-full h-auto
                    peer-checked/VGVOption1:bg-slate-200 p-2 rounded-xl
                    flex flex-row items-center justify-between gap-4 hover:bg-slate-100">
                    <span>Pessimista (10%)</span>
                    <span className="font-semibold">
                        {
                            Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                                unitDisplay: 'short'
                            }).format(PESSIMISTA)
                        }
                    </span>
                </label>

                <label title="Clique para selecionar" htmlFor="vgv_otimista" onClick={() => setHouseAmount(OTIMISTA)} className="w-full h-auto
                    peer-checked/VGVOption2:bg-slate-200 p-2 rounded-xl
                    flex flex-row items-center justify-between gap-4 hover:bg-slate-100">
                    <span>Otimista (10%)</span>
                    <span className="font-semibold">
                        {
                            Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                                unitDisplay: 'short'
                            }).format(OTIMISTA)
                        }
                    </span>
                </label>
            </span>
        </span>
    )
}
